var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{attrs:{"id":"layout-wrapper"}},[_c('app-header-bar',{attrs:{"user":_vm.$store.state.users.name}}),_c('app-side-bar',{attrs:{"boards":_vm.boardsData}}),_c('router-view',{key:_vm.$route.fullPath,attrs:{"boards":_vm.boardsData.data}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }